export default "__VITE_ASSET__B7L6MmAW__"